var _path, _path2, _path3, _path4, _path5, _path6, _rect;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgButterfly(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 21 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.4279 8.72851C9.47779 10.3742 6.99369 10.7368 4.87033 9.51083C2.74698 8.28491 1.81894 5.95233 2.76906 4.30667C3.71918 2.66101 6.20328 2.29843 8.32663 3.52435C10.45 4.75027 11.378 7.08285 10.4279 8.72851Z",
    fill: "#5493E1",
    stroke: "#5493E1",
    strokeWidth: 0.0808014
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.8213 10.1283C11.1617 10.7178 11.1379 11.4475 10.8174 12.1539C10.4968 12.8602 9.88066 13.5398 9.04356 14.0231C8.20645 14.5064 7.30982 14.7002 6.53788 14.6247C5.76585 14.5491 5.122 14.2048 4.78163 13.6153C4.44126 13.0258 4.46505 12.296 4.78562 11.5896C5.10615 10.8833 5.72232 10.2037 6.55942 9.72044C7.39653 9.23714 8.29316 9.04332 9.0651 9.11888C9.83713 9.19446 10.481 9.53872 10.8213 10.1283Z",
    fill: "#5493E1",
    stroke: "#5493E1",
    strokeWidth: 0.0808014
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5579 8.72851C12.5081 10.3742 14.9921 10.7368 17.1155 9.51083C19.2389 8.28491 20.1669 5.95233 19.2168 4.30667C18.2667 2.66101 15.7826 2.29843 13.6592 3.52435C11.5358 4.75027 10.6078 7.08285 11.5579 8.72851Z",
    fill: "#5493E1",
    stroke: "#5493E1",
    strokeWidth: 0.0808014
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.165 10.1283C10.8246 10.7178 10.8484 11.4475 11.169 12.1539C11.4895 12.8602 12.1057 13.5398 12.9428 14.0231C13.7799 14.5064 14.6765 14.7002 15.4484 14.6247C16.2205 14.5491 16.8643 14.2048 17.2047 13.6153C17.5451 13.0258 17.5213 12.296 17.2007 11.5896C16.8802 10.8833 16.264 10.2037 15.4269 9.72044C14.5898 9.23714 13.6932 9.04332 12.9212 9.11888C12.1492 9.19446 11.5053 9.53872 11.165 10.1283Z",
    fill: "#5493E1",
    stroke: "#5493E1",
    strokeWidth: 0.0808014
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.0211 5.77644C10.9074 4.25935 9.87101 1.14079 6.63525 0.803223",
    stroke: "current",
    strokeWidth: 0.808014
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9979 5.77644C11.1117 4.25935 12.148 1.14079 15.3838 0.803223",
    stroke: "current",
    strokeWidth: 0.808014
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9.46338,
    y: 5.64117,
    width: 3.07045,
    height: 5.41369,
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgButterfly);
export default __webpack_public_path__ + "static/media/butterfly.04fbd7c077257e79b1008cff7ebab3fb.svg";
export { ForwardRef as ReactComponent };